import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';
import { formatDateTime } from '@/lib/utils';
import type { ForecastAnomaly } from '../types';
import AnomalyBadge from './AnomalyBadge';

interface AnomalyTableProps {
  anomalies: ForecastAnomaly[];
  isLoading?: boolean;
}

export default function AnomalyTable({ anomalies, isLoading }: AnomalyTableProps) {
  if (isLoading) {
    return (
      <div className="border rounded-lg p-8 text-center text-muted-foreground">
        Loading anomalies...
      </div>
    );
  }

  if (anomalies.length === 0) {
    return (
      <div className="border rounded-lg p-8 text-center text-muted-foreground">
        No anomalies detected
      </div>
    );
  }

  return (
    <div className="border rounded-lg overflow-hidden">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Detected</TableHead>
            <TableHead>Sensor</TableHead>
            <TableHead>Type</TableHead>
            <TableHead>Severity</TableHead>
            <TableHead className="text-right">Actual</TableHead>
            <TableHead className="text-right">Predicted</TableHead>
            <TableHead className="text-right">Band (q10-q90)</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {anomalies.map((anomaly, i) => (
            <TableRow key={`${anomaly.sensor_id}-${anomaly.detected_at}-${i}`}>
              <TableCell className="text-sm">
                {formatDateTime(anomaly.detected_at)}
              </TableCell>
              <TableCell className="font-mono text-xs">
                {(anomaly.sensor_id || '').slice(0, 12)}...
              </TableCell>
              <TableCell className="text-sm">{anomaly.anomaly_type}</TableCell>
              <TableCell>
                <AnomalyBadge severity={anomaly.severity} />
              </TableCell>
              <TableCell className="text-right font-mono text-sm">
                {anomaly.actual_value?.toFixed(2) ?? '-'}
              </TableCell>
              <TableCell className="text-right font-mono text-sm">
                {anomaly.predicted_mean.toFixed(2)}
              </TableCell>
              <TableCell className="text-right font-mono text-sm text-muted-foreground">
                {anomaly.predicted_q10.toFixed(2)} – {anomaly.predicted_q90.toFixed(2)}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}
